import React, { useState } from "react";
import "@styles/SingleHotelViewcss/OrderTable.css";
import { useFoodcourtStaff } from "@hooks/users/foodcourtStaff/useStaff";

const FoodcourtTable: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 7;
    const { data, isLoading, error } = useFoodcourtStaff();

    // Handle loading state
    if (isLoading) {
        return <div>Loading...</div>;
    }

    const totalPages = Math.ceil((data?.length || 0) / recordsPerPage);

    // Get current records for the page
    const currentRecords = data?.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    ) || [];

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const handlePageClick = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div className="transaction-table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Username</th>
                            <th>Foodcourt Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Last Login</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.map((customer: any, index: number) => (
                            <tr key={index}>
                                <td style={{textTransform:"capitalize"}}>{customer.username}</td>
                                <td style={{textTransform:"capitalize"}}>{customer.foodCourtName}</td>
                                <td>{customer.email}</td>
                                <td>{customer.phonenumber || "+91 987654321"}</td>
                                <td>{customer.lastLogin || "N/A"}</td>
                                <td>
                                    <button
                                        className="view-details-button"
                                        style={{ padding: "20px 5px" }}
                                        onClick={() => alert("Details")}
                                    >
                                        <span>View Details</span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="pagination-controls">
                <span>
                    {currentPage} of {totalPages}
                </span>
                <div style={{ display: 'flex', justifyContent: "center", gap: "10px" }}>
                    <button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="pagination-button"
                    >
                        {"<"}
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => handlePageClick(index + 1)}
                            className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                        className="pagination-button"
                    >
                        {">"}
                    </button>
                </div>
            </div>
        </>
    );
};

export default FoodcourtTable;
